// "Your tasks" on the Dashboard (Today, Top tasks), by the one ownership rule (Carla, 2026-10-11):
// the assignees if there are any, otherwise the creator (utils/taskTime isTaskResponsibility, which
// the server's lib/myTasks also uses). The old filter took creator OR a bare-id assignee, so a task
// you had handed to a colleague stayed on your Dashboard and one assigned to you as { userId } (stage
// automations, the task form) never reached it. External calendar events pass through untouched.
import { isTaskResponsibility } from './taskTime';

export function filterMyTasks(tasks, currentUser, isExternal = () => false) {
  if (!currentUser) return [];
  return tasks.filter((task) => isExternal(task) || isTaskResponsibility(task, currentUser.id));
}
